import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { translation } from '../../utils/PageInfoTranslator';

// ====

const SEO = (props) => {
  const { meta, settings, href, openGraph, mode } = props;

  const page = translation(meta, openGraph, settings);

  if (mode === 'debug') {
    return (
      <div className="row">
        <div className="col-12 p-5 border brand-background-black">
          <h3>Debug Translator</h3>
          <p>Domain: {page.domain}</p>
          <p>Page URL: {page.url}</p>
          <p>Page title: {page.pageTitle}</p>
          <p>Description: {page.description}</p>
          {page.type ? <p>Type: {page.type} </p> : <p>[No type set]</p>}
          {page.author ? <p>Type: {page.author} </p> : <p>[No author set]</p>}
          <p>SEO title: {page.title}</p>
          <p>Site name: {page.siteName}</p>

          <p>
            Image path: <img src={page.image} width="100" alt={page.title} />{' '}
            {page.image} || {page.imageSquare}
          </p>
          <p>
            FB Pages value:{' '}
            {page.meta_fb_pages ? page.meta_fb_pages : 'Not set'}
          </p>
          {openGraph.noIndex === true && <p>Meta: noIndex</p>}
        </div>
      </div>
    );
  }

  return (
    <Helmet>
      <title>{page.pageTitle}</title>
      <link rel="canonical" href={`${page.url}`} />
      <meta name="description" content={page.description} />
      <meta property="og:url" content={`${page.url}`} />
      {page.type && <meta property="og:type" content={page.type} />}
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:site_name" content={page.siteName} />
      <meta property="og:image" content={page.image} />
      <meta property="og:image:alt" content={page.title} />
      <meta property="og:image:width" content="960" />
      <meta property="og:image:height" content="540" />
      {page.author && <meta property="og:author" content={page.author} />}
      {settings.twitter && (
        <meta name="twitter:site" content={settings.twitter} />
      )}
      {page.author && <meta name="twitter:creator" content={page.author} />}
      <meta name="twitter:card" content="summary_large_image" />
      {page.meta_fb_pages && (
        <meta property="fb:pages" content={page.meta_fb_pages} />
      )}

      {openGraph.noIndex === true && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default SEO;

SEO.propTypes = {
  mode: PropTypes.string,
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  openGraph: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SEO.defaultProps = {
  mode: 'helmet',
  meta: null,
  settings: null,
  openGraph: {
    title: 'Hutch',
    description: '',
    richtext: true,
    author: '',
    image: '',
    type: 'website',
  },
};
